export class BlackfridayObserver{

  constructor(btn){
    this.btnToggle = btn;
  }

  next(brandsSliced) {
    Array.prototype.forEach.call(brandsSliced, brand => {
      if (brand.getAttribute('style') == null) {
        brand.style.cssText = 'display: inline-block !important';
        this.btnToggle.innerHTML = 'Reduzir área de marcas';
      } else {
        brand.removeAttribute('style');
        this.btnToggle.innerHTML = 'Ver Mais Marcas';
      }
    });
    window.scrollTo(0, 430);
  }

  error(error) {

  }

  complete() {

  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/components/blackfriday/blackfriday.observer.js